export default "__VITE_ASSET__qkHrcXdT__"